import React, { useState, useEffect, useRef } from "react";
import { Button, Modal, Row } from "react-bootstrap";
import StoreInfoForm from "./StoreInfoForm";
import EventInfoForm from "./EventInfoForm";
import { createTimeString } from "./DTCommonFunctions";

import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";
import "datatables.net-select-bs5";
import "datatables.net-responsive-bs5";
import LinkRPHStoreForm from "./LinkRPHStoreForm";

DataTable.use(DT);

const SetChampTool = ({ authData, Stores, ReloadStores, Events, ReloadEvents }) => {
  //const [scInfo, setSCInfo] = useState({});
  const [mapNewStoreData, setMapNewStoreData] = useState([]);
  const [newStorePreLoadModel, setNewStorePreLoadModel] = useState({ Address: "", Latitude: "", Longitude: "", Storename: "", RPHStoreId: "" });
  const [showStoreFormModal, setShowStoreFormModal] = useState(false);

  const handleShowStoreFormModal = () => setShowStoreFormModal(true);
  const handleCloseStoreFormModal = () => setShowStoreFormModal(false);

  const displayNewModal = (data) => {
    console.log(data);
    setNewStorePreLoadModel({ Address: data.address, Latitude: data.latitude, Longitude: data.longitude, Storename: data.storeName, RPHStoreId: data.rphStoreId });
    handleShowStoreFormModal();
  };

  const [showLinkStoreModal, setShowLinkStoreModal] = useState(false);
  const [rphLinkID, setrphLinkID] = useState({});
  const [unlinkedStores, setUnlinkedStores] = useState([]);

  const handleShowLinkStoreModal = () => setShowLinkStoreModal(true);
  const handleCloseLinkStoreModal = () => setShowLinkStoreModal(false);
  const displayLinkStoreModal = (data) => {
    console.log(data);
    setrphLinkID(data);
    handleShowLinkStoreModal();
  };

  const mapNewStoreTableRef = useRef(null);

  const columnDefs = [
    { data: "storeName", title: "Store", responsivePriority: 1 },
    { data: "address", title: "Address", width: "40%", responsivePriority: 3 },
    { title: "Add/Link", orderable: false, visible: authData.isAuthenticated && authData.user.roles.indexOf("God") != -1, data: null, responsivePriority: -1 },
  ];

  const mapNewStoreTableSlots = {
    2: (data, row) => (
      <>
        <Button variant="info" onClick={() => displayNewModal(data, row)}>
          Add as New Store
        </Button>
        &nbsp;
        <Button variant="outline-success" onClick={() => displayLinkStoreModal(data, row)}>
          Link to Existing Store
        </Button>
      </>
    ),
  };

  const [eventPreLoadModel, setEventPreLoadModel] = useState({ StoreId: 0, EventType: "Set Champ", DateOfEvent: "", TimeOfEvent: "", Cost: "", MeleeUrl: "" });
  const [mapNewEventData, setMapNewEventData] = useState([]);
  const [mapEditEventData, setMapEditEventData] = useState([]);
  const [editEventId, setEditEventId] = useState(0);

  const [showEventFormModal, setShowEventFormModal] = useState(false);
  const handleShowEventFormModal = () => setShowEventFormModal(true);
  const handleCloseEventFormModal = () => setShowEventFormModal(false);

  const displayNewEventModal = (data) => {
    console.log(data);
    setEditEventId(0);
    setEventPreLoadModel({
      EventType: "Set Champ",
      StoreId: data.internalStoreId,
      DateOfEvent: data.dateString,
      TimeOfEvent: data.timeCode,
      Cost: data.cost,
      MeleeUrl: "https://tcg.ravensburgerplay.com/events/" + data.rphEventId,
    });
    handleShowEventFormModal();
  };

  const displayEditEventModal = (data) => {
    console.log(data);
    setEditEventId(data.internalEventId);
    setEventPreLoadModel({
      EventType: "Set Champ",
      DateOfEvent: data.dateString,
      TimeOfEvent: data.timeCode,
      StoreId: data.internalStoreId,
      Cost: data.cost,
      MeleeUrl: "https://tcg.ravensburgerplay.com/events/" + data.rphEventId,
    });
    handleShowEventFormModal();
  };

  const mapNewEventTableRef = useRef(null);

  const columnDefsNewEvents = [
    { data: "storeName", title: "Store", responsivePriority: 1 },
    { data: "dateString", title: "Date", responsivePriority: 2 },
    {
      data: "timeCode",
      title: "Time",
      render: (data) => {
        return createTimeString(data);
      },
      responsivePriority: 3,
    },
    { title: "Add/Link", orderable: false, visible: authData.isAuthenticated && authData.user.roles.indexOf("God") != -1, data: null, responsivePriority: -1 },
  ];

  const mapNewEventsTableSlots = {
    3: (data, row) => (
      <>
        <Button variant="info" onClick={() => displayNewEventModal(data, row)}>
          Add as New Event
        </Button>
      </>
    ),
  };

  const mapEditEventTableRef = useRef(null);

  const columnDefsEditEvents = [
    { data: "storeName", title: "Store", responsivePriority: 1 },
    { data: "dateString", title: "New Date", responsivePriority: 2 },
    {
      data: "timeCode",
      title: "New Time",
      render: (data) => {
        return createTimeString(data);
      },
      responsivePriority: 3,
    },
    { data: "originalStartDate", title: "Original Date", responsivePriority: 2 },
    {
      data: "originalTimeCode",
      title: "Original Time",
      render: (data) => {
        return createTimeString(data);
      },
      responsivePriority: 3,
    },
    { title: "Update", orderable: false, visible: authData.isAuthenticated && authData.user.roles.indexOf("God") != -1, data: null, responsivePriority: -1 },
  ];

  const mapEditEventsTableSlots = {
    5: (data, row) => (
      <>
        <Button variant="info" onClick={() => displayEditEventModal(data, row)}>
          Update Event
        </Button>
      </>
    ),
  };

  useEffect(() => {
    fetch("IEEService/GetCurrentSetChampInfo/", {
      mode: "cors",
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        console.log(data.setchamps);
        //setSCInfo(data.data);
        setMapNewStoreData(data.setchamps.nonLinkedStores);
        setUnlinkedStores(data.setchamps.storesWithoutRPHLink);
        setMapNewEventData(data.setchamps.eventsNeedingAdding);
        setMapEditEventData(data.setchamps.eventsNeedingUpdates);
      });
  }, [Stores, Events]);

  return (
    <>
      <Row>
        <Row>
          <h2>Possible new stores or stores needing RPH Link</h2>

          <DataTable
            key={1}
            className="table table-bordered"
            data={mapNewStoreData}
            options={{
              responsive: true,
              columns: columnDefs,
              bDestroy: true,
            }}
            tableRef={mapNewStoreTableRef}
            slots={mapNewStoreTableSlots}
          >
            <thead></thead>
          </DataTable>
        </Row>

        <Row>
          <h2>Events that need to be added</h2>
          <DataTable
            key={2}
            className="table table-bordered"
            data={mapNewEventData}
            options={{
              responsive: true,
              columns: columnDefsNewEvents,
              bDestroy: true,
            }}
            tableRef={mapNewEventTableRef}
            slots={mapNewEventsTableSlots}
          >
            <thead></thead>
          </DataTable>
        </Row>
        <Row>
          <h2>Events that may need updates</h2>
          <DataTable
            key={3}
            className="table table-bordered"
            data={mapEditEventData}
            options={{
              responsive: true,
              columns: columnDefsEditEvents,
              bDestroy: true,
            }}
            tableRef={mapEditEventTableRef}
            slots={mapEditEventsTableSlots}
          >
            <thead></thead>
          </DataTable>
        </Row>
        <Modal show={showStoreFormModal} onHide={handleCloseStoreFormModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Add New Store</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <StoreInfoForm StoreId={0} CloseModal={handleCloseStoreFormModal} ReloadStores={ReloadStores} PreLoadModel={newStorePreLoadModel}></StoreInfoForm>
          </Modal.Body>
        </Modal>

        <Modal show={showLinkStoreModal} onHide={handleCloseLinkStoreModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Link to Existing</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <LinkRPHStoreForm RPHStoreInfo={rphLinkID} CloseModal={handleCloseLinkStoreModal} ReloadStores={ReloadStores} Stores={unlinkedStores}></LinkRPHStoreForm>
          </Modal.Body>
        </Modal>

        <Modal show={showEventFormModal} onHide={handleCloseEventFormModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Edit Event</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EventInfoForm EventId={editEventId} CloseModal={handleCloseEventFormModal} Stores={Stores} ReloadEvents={ReloadEvents} PreLoadModel={eventPreLoadModel}></EventInfoForm>
          </Modal.Body>
        </Modal>
      </Row>
    </>
  );
};
export default SetChampTool;
